import { AxiosInstance } from "axios";

import { ICatchIssueUseCase } from '../catch-issue.usecase';

interface IHandleDTO {
  token: string;
  asset_id: string;
}

interface IHandleResponse {
  error: boolean;
  message: string;
}

interface IDeleteBookmarkAssetUseCase {
  handle(params: IHandleDTO): Promise<IHandleResponse>;
}

export class DeleteBookmarkAssetUseCase implements IDeleteBookmarkAssetUseCase {
  constructor(
    private readonly url: string,
    private readonly http: AxiosInstance,
    private readonly catchIssueUseCase: ICatchIssueUseCase
  ) {}

  async handle({
    token,
    asset_id
  }: IHandleDTO): Promise<IHandleResponse> {
    try {
      await this.http.delete(`${this.url}/${asset_id}`);

      return {
        error: false,
        message: 'Fundo removida dos favoritos com sucesso'
      };

    } catch (error) {
      this.catchIssueUseCase.handle({
        error,
        errorName: 'DeleteBookmarkAssetUseCase',
        extras: {
          token,
          asset_id
        }
      });

      return {
        error: true,
        message: 'Não foi possível remover o fundo dos favoritos, tente novamente mais tarde'
      }
    }
  }
}